import { IconsType } from '../components/shared'

export type DeviceKind = 'desktop' | 'mobile' | 'tablet'

const TABLET_HINTS = ['tablet', 'tablette', 'ipad']

/**
 * Détermine le type d'appareil à partir des champs `mobile` et `device`
 * renvoyés par l'API sessions.
 */
export const getDeviceKind = (mobile: boolean, device?: string | null): DeviceKind => {
  const normalizedDevice = (device ?? '').toLowerCase()
  const looksLikeTablet = TABLET_HINTS.some((hint) => normalizedDevice.includes(hint))

  if (looksLikeTablet) {
    return 'tablet'
  }

  return mobile ? 'mobile' : 'desktop'
}

const DEVICE_ICON_MAPPING: { [kind in DeviceKind]: IconsType } = {
  desktop: 'desktop',
  mobile: 'smartphone',
  tablet: 'tablet',
}

/** Icône contextuelle (desktop / mobile / tablette) pour un device. */
export const getDeviceIcon = (mobile: boolean, device?: string | null): IconsType =>
  DEVICE_ICON_MAPPING[getDeviceKind(mobile, device)]

const DEVICE_LABEL_MAPPING: { [kind in DeviceKind]: string } = {
  desktop: 'Ordinateur',
  mobile: 'Mobile',
  tablet: 'Tablette',
}

/** Libellé lisible du type d'appareil (utile pour l'accessibilité). */
export const getDeviceKindLabel = (mobile: boolean, device?: string | null): string =>
  DEVICE_LABEL_MAPPING[getDeviceKind(mobile, device)]
